import request from '@/utils/request'

export function selectCustomerUser(data) {
  return request({
    url: '/sysUser/querySysUserList',
    method: 'post',
    data
  })
}

export function queryCenterSysUserList(data) {
  return request({
    url: '/sysUser/queryCenterSysUserList',
    method: 'post',
    data
  })
}

export function queryMaintainerSysUserList(data) {
  return request({
    url: '/sysUser/queryMaintainerSysUserList',
    method: 'post',
    data
  })
}

export function queryCustomerUserOptions() {
  return request({
    url: '/sysUser/queryCustomerUserOptions',
    method: 'post'
  })
}

export function queryCustomerUserList(data) {
  return request({
    url: '/sysUser/queryCustomerUserList',
    method: 'post',
    data
  })
}

export function querySysUserByMobile(mobile) {
  return request({
    url: '/sysUser/querySysUserByMobile',
    method: 'post',
    params: { mobile }
  })
}

export function changeUserType(data) {
  return request({
    url: '/sysUser/changeUserTypeFromCustomerToCenter',
    method: 'post',
    params: data
  })
}

export function changeUserTypeToProvider(data) {
  return request({
    url: '/sysUser/changeFromCustomerToProvider',
    method: 'post',
    params: data
  })
}

// export function selectMaintainers(data) {
//   return request({
//     url: '/sysUser/queryMaintainerList',
//     method: 'post',
//     data
//   })
// }

export function createCustomerUser(data) {
  return request({
    url: '/sysUser/addSysUser',
    method: 'post',
    data
  })
}

export function addCenterUser(data) {
  return request({
    url: '/sysUser/addCenterUser',
    method: 'post',
    data
  })
}

export function addMaintainerUser(data) {
  return request({
    url: '/sysUser/addMaintainerUser',
    method: 'post',
    data
  })
}

export function updSysUserPassword(data) {
  return request({
    url: '/sysUser/updSysUserPassword',
    method: 'post',
    data
  })
}

export function resetSysUserPassword(data) {
  return request({
    url: '/sysUser/resetSysUserPassword',
    method: 'post',
    data
  })
}

export function updateCustomerUser(data) {
  return request({
    url: '/sysUser/updSysUser',
    method: 'post',
    data
  })
}

export function updCenterUser(data) {
  return request({
    url: '/sysUser/updCenterUser',
    method: 'post',
    data
  })
}

export function updMaintainerUser(data) {
  return request({
    url: '/sysUser/updMaintainerUser',
    method: 'post',
    data
  })
}

export function updUserCompany(data) {
  return request({
    url: '/sysUser/updUserCompany',
    method: 'post',
    data
  })
}

export function delMultipleCustomerUser(data) {
  return request({
    url: '/sysUser/delMultipleSysUser',
    method: 'post',
    data
  })
}

export function querySysUserOptions(companyId) {
  return request({
    url: '/sysUser/querySysUserOptions',
    method: 'post',
    params: { companyId }
  })
}

export function enableSysUser(data) {
  return request({
    url: '/sysUser/enableSysUser',
    method: 'post',
    data
  })
}
// 服务商管理-人员管理
export function selectUserList(data) {
  return request({
    url: '/cuUser/queryUserList',
    method: 'post',
    data
  })
}
// 服务商管理-人员管理 添加人员
export function addUser(data) {
  return request({
    url: '/cuUser/addUser',
    method: 'post',
    data
  })
}
export function updateUser(data) {
  return request({
    url: '/cuUser/updateUser',
    method: 'post',
    data
  })
}

